"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
// eslint-disable-next-line import/prefer-default-export
exports.setIsInternetConnected = function (isConnected) {
    return toolkit_1.createAction(constants_1.SET_INTERNET_CONNECTED)(isConnected);
};
exports.setInternetSource = function (source) { return toolkit_1.createAction(constants_1.SET_INTERNET_SOURCE)(source); };
//# sourceMappingURL=actions.js.map